import $ from 'jquery';
import notifications from './notifications.js';
import { eventType } from './config/settings.js';
import { sessionKey } from './store/cookies.js';
import { pushBack } from './store/history.js';
import accountInfo from './account-info.js';
import menuesRootview from './menues_rootview.js';
import spinner from './spinner.js';

const $verifyEmailMenu = $('.js-verify_email');
const $myAccountSettings = $('.my-account-settings-content');
const $verifyEmailWrapper = $('.js-verify_email');
const $editEmailWrapper = $myAccountSettings.find('.js-edit_email');
const $newEmail = $editEmailWrapper.find('#new-email');
const $verifyEmailCloseBttn = $verifyEmailWrapper.find('.icon-close');
const $sendBttn = $verifyEmailWrapper.find('.btn-send-mail');
const $alreadyVerifiedResponse = $verifyEmailMenu.find('#mail-verify-already-text');
const changedMailMessage = $verifyEmailWrapper.find('.mail-change').data('value');
const sentVerifyMailMessage = $verifyEmailWrapper.find('.mail-sent-verify').data('value');
const $mailField = $verifyEmailWrapper.find('#verify-email');
let userMail = '';
let unconfMail = '';
let userMailVerificationStatus = false;

$verifyEmailCloseBttn.click((e) => {
	e.preventDefault();
	e.stopPropagation();
	pushBack();
});

function changeEmail(changeMessage, optionalCallback, newEmail = $newEmail) {
	if (sessionKey()) {
		const email = newEmail;

		const data = {
			string: email
		};

		$.ajax({
			url: '/player/email',
			type: 'POST',
			data: JSON.stringify(data),
			contentType: 'application/json; charset=utf-8'
		}).done((resultData) => {
			if (resultData.status === 'SUCCESS' && resultData.result) {
				notifications.showNotification(changeMessage, 'green', true);
				$verifyEmailWrapper.find('.email-to-verify').text(resultData.result);
				$newEmail.attr('placeholder', resultData.result);
				$editEmailWrapper.removeClass('notify--is-open');
				optionalCallback && optionalCallback.call();
			}
			if (resultData.status === 'FAILURE') {
				notifications.showNotification(resultData.errorDescription, 'red', true);
				console.error(`Error changeEmail: ${resultData.errorDescription}. Code: ${resultData.errorCode}`);
			}
		}).fail((jqXHR, textStatus, errorThrown) => {
			console.error(jqXHR, textStatus, errorThrown);
		}).always(() => {
			spinner.hide($sendBttn.parent());
		});
	}
}

function resendEmailVerify(resendMessage) {
	if (sessionKey()) {
		$.ajax({
			url: '/player/email/verify/resend/',
			type: 'POST',
			contentType: 'application/json; charset=utf-8'
		}).done((resultData) => {
			if (resultData.status === 'SUCCESS' && resultData.result) {
				//  Show green notification with message
				notifications.showNotification(resendMessage, 'green', true);

			}
			if (resultData.status === 'FAILURE') {
				notifications.showNotification(resultData.errorDescription, 'red', true);
				console.error(`Error resendEmailVerify ${resultData.errorDescription}. Code: ${resultData.errorCode}`);
			}
		}).fail((jqXHR, textStatus, errorThrown) => {
			console.error(jqXHR, textStatus, errorThrown);
		}).always(() => {
			spinner.hide($sendBttn.parent());
		});
	}
}

function verifyEmail(verifyMessage, verifyStatusErrorMessage) {
	if (sessionKey()) {
		$.ajax({
			url: '/player/email/verify',
			type: 'GET',
			contentType: 'application/json; charset=utf-8'
		}).done((resultData) => {
			if (resultData.status === 'SUCCESS') {
				if (resultData.result) {
					notifications.showNotification(verifyMessage, 'green', true);
					accountInfo.setVerificationEmail(true);
					menuesRootview.closeVerifyEmail();
				} else {
					notifications.showNotification(verifyStatusErrorMessage, 'red', true);
				}
			}
			if (resultData.status === 'FAILURE') {
				notifications.showNotification(resultData.errorDescription, 'red', true);
				console.error(`Error verifyEmail ${resultData.errorDescription}. Code: ${resultData.errorCode}`);
			}
		}).fail((jqXHR, textStatus, errorThrown) => {
			console.error(jqXHR, textStatus, errorThrown);
		});
	}
}


$sendBttn.click(() => {
	const mailToSend = $mailField.val().toLowerCase();
	function resend() {
		resendEmailVerify(`${sentVerifyMailMessage} ${mailToSend}`);
		accountInfo.getPlayerInfo();
	}

	function showAlreadyVerifiedNotification() {
		notifications.showNotification($alreadyVerifiedResponse.text(), 'red', true);
		spinner.hide($sendBttn.parent());
	}

	spinner.show($sendBttn.parent());

	if (userMailVerificationStatus) {
		if (mailToSend === userMail) {
			showAlreadyVerifiedNotification();
		} else if (unconfMail && mailToSend === unconfMail) {
			resend();
		} else {
			changeEmail(`${changedMailMessage} ${mailToSend}`, resend, mailToSend);
		}
	} else {
		if (mailToSend === userMail || (unconfMail && mailToSend === unconfMail)) {
			resend();
		} else {
			changeEmail(`${changedMailMessage} ${mailToSend}`, resend, mailToSend);
		}
	}


});

function setUserMail(mail, unconf) {
	userMail = mail;
	unconf && (unconfMail = unconf);
	$mailField.attr('value', userMail);
}

function setMailVerificationStatus(isVerified) {
	userMailVerificationStatus = isVerified;
}

function setActive(bool) {
	if (bool) {
		if (!$mailField.val()) {

			accountInfo.getPlayerInfo();
		}
		$verifyEmailWrapper.addClass('menu--is-open');
		document.documentElement.classList.add('overlay--open');
		$verifyEmailWrapper.find('.js-mail-verify-step1').addClass('slide-in-left');
	} else {
		$verifyEmailWrapper.removeClass('menu--is-open');
		document.documentElement.classList.remove('overlay--open');
		$verifyEmailWrapper.find('.js-mail-verify-step1').removeClass('slide-in-left');
	}
}

// open edit email modal window
$verifyEmailWrapper.find('.js-editemail').on(eventType, () => {
	$editEmailWrapper.addClass('notify--is-open');
	return false;
});

// change email
$editEmailWrapper.find('.js-changeemail').on(eventType, function () {
	const changeMessage = $(this).data('message');
	changeEmail(changeMessage);
	return false;
});

// resend email
$verifyEmailWrapper.find('.js-resendemail').on(eventType, function () {
	const resendMessage = $(this).data('message');
	resendEmailVerify(resendMessage);
	return false;
});

// verify email
$verifyEmailWrapper.find('.js-verifyemail').on(eventType, function () {
	const verifyMessage = $(this).data('message');
	const verifyStatusErrorMessage = $(this).data('status-error');
	verifyEmail(verifyMessage, verifyStatusErrorMessage);
	return false;
});

export default {
	changeEmail,
	resendEmailVerify,
	verifyEmail,
	setActive,
	setUserMail,
	setMailVerificationStatus
};




// WEBPACK FOOTER //
// ./mobile-core/src/account-settings-email.js